import type { Adventure } from '../../types'

// Ordinal Numbers Adventure - Age 4-5 - First, Second, Third
export const tillyOrdinalCorrect = [
  "Perfect! You know your positions!",
  "That's right! First, second, third!",
  "Excellent! You understand order!",
  "Wonderful! You know the sequence!",
  "Yes! That's the right position!",
  "Brilliant! You're in the right place!",
  "Super job! First, second, third, fourth!",
  "You got it! That's the order!",
  "Fantastic! You know positions!",
  "Amazing! You understand ranking!"
]

export const tillyOrdinalWrong = [
  "Let's try again! First is number 1!",
  "Almost! First comes before second!",
  "Good try! Think about a race - who comes first?",
  "So close! First, then second, then third!",
  "Count with me: 1st, 2nd, 3rd!",
  "You're learning! What position is number 1?",
  "Try again! First place is the winner!",
  "Think about the order: 1st, 2nd, 3rd!",
  "Let's count positions together!",
  "Keep trying! You'll get it!"
]

export const ordinalNumbersAdventure: Adventure = {
  id: 'ordinal-numbers',
  title: 'First, Second, Third',
  theme: 'numbers',
  targetAge: '4',
  difficulty: 'medium',
  estimatedDuration: 9,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello! I am Tilly! Today we are learning about positions! First, second, third - just like a race!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at the race! The rabbit came FIRST! The turtle came SECOND! The bird came THIRD! Can you spot who is first?",
      duration: 5
    },
    choice1: [
      {
        id: 'race',
        label: 'Race positions!',
        tillyLine: "Who won the race?",
        nextState: 'quiz-1'
      },
      {
        id: 'line',
        label: 'Stand in line!',
        tillyLine: "Let's line up properly!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'number-recognition',
      question: 'Who crossed the line FIRST?',
      tillyPrompt: '🐰 🐢 🐦 Who is first?',
      options: [
        { id: 'rabbit', label: '🐰 Rabbit', isCorrect: true },
        { id: 'turtle', label: '🐢 Turtle', isCorrect: false },
        { id: 'bird', label: '🐦 Bird', isCorrect: false }
      ],
      targetNumber: 1
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great! Now let's line up for ice cream! First in line gets served first! Who is SECOND in line?",
      duration: 4
    },
    choice2: [
      {
        id: 'queue',
        label: 'Ice cream line!',
        tillyLine: "I scream for ice cream!",
        nextState: 'quiz-2'
      },
      {
        id: 'bus',
        label: 'Bus stop line!',
        tillyLine: "All aboard!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'number-recognition',
      question: 'Who is SECOND in line?',
      tillyPrompt: '👦 👧 👶 Who is second?',
      options: [
        { id: 'boy', label: '👦 Boy', isCorrect: false },
        { id: 'girl', label: '👧 Girl', isCorrect: true },
        { id: 'baby', label: '👶 Baby', isCorrect: false }
      ],
      targetNumber: 2
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Position expert! Challenge Round: First, second, third, fourth, and last!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'number-recognition',
          question: 'In a race of 5 friends, who is FOURTH?',
          tillyPrompt: '🐶 🐱 🐭 🐹 🐰 Who is 4th?',
          options: [
            { id: 'dog', label: '🐶 1st', isCorrect: false },
            { id: 'cat', label: '🐱 2nd', isCorrect: false },
            { id: 'mouse', label: '🐭 3rd', isCorrect: false },
            { id: 'hamster', label: '🐹 4th', isCorrect: true }
          ],
          targetNumber: 4
        } as any,
        {
          id: 'challenge-2',
          type: 'number-recognition',
          question: 'Who is LAST (fifth) in line?',
          tillyPrompt: '🍎 🍊 🍋 🍇 🍓 Who is last?',
          options: [
            { id: 'apple', label: '🍎 1st', isCorrect: false },
            { id: 'strawberry', label: '🍓 5th', isCorrect: true },
            { id: 'grapes', label: '🍇 4th', isCorrect: false }
          ],
          targetNumber: 5
        } as any,
        {
          id: 'challenge-3',
          type: 'number-recognition',
          question: 'What position is the middle one?',
          tillyPrompt: '⭐ 🌙 ☀️ ☁️ 🌈 Five items - who is in the middle?',
          options: [
            { id: 'star', label: '⭐ 1st', isCorrect: false },
            { id: 'sun', label: '☀️ 3rd', isCorrect: true },
            { id: 'rainbow', label: '🌈 5th', isCorrect: false }
          ],
          targetNumber: 3
        } as any
      ]
    },
    reward: {
      tillyLine: "Incredible! You mastered first, second, third, and beyond! You're an Ordinal Champion!",
      badgeName: 'Position Pro',
      badgeIcon: '🏆',
      nextPreview: 'Next time, we will compare big and small!'
    }
  }
}
